export function parseError(error: unknown) {
  if (error === null) {
    return {
      message: "Message is null",
      asJson: JSON.stringify(error, null, 2),
      stack: [],
    };
  }

  if (typeof error !== "object") {
    return {
      message: "Message is not an object",
      asJson: JSON.stringify(error, null, 2),
      stack: [],
    };
  }

  const name = "name" in error ? error.name : "No name";
  const message = "message" in error ? error.message : "No message";
  const stack =
    "stack" in error && typeof error.stack === "string"
      ? error.stack.split("\n")
      : [];

  return {
    name,
    message,
    stack,
    asJson: JSON.stringify(error, null, 2),
  };
}
